// React
import { useCallback } from 'react'

// Styles
import styles from './index.module.scss'

// Interfaces
import { IBaseAssessmentStepProps } from './interfaces'
import { IAssessmentDetailStep } from 'interfaces/back-office/assessment'

// Images
import StepFirst from 'assets/images/assessment/step-first.png'
import StepEnd from 'assets/images/assessment/step-end.png'
import StepEndActive from 'assets/images/assessment/step-end-active.png'
import StepMiddle from 'assets/images/assessment/step-middle.png'
import StepFirstActive from 'assets/images/assessment/step-first-active.png'
import StepActiveMiddle from 'assets/images/assessment/step-middle-active.png'

// Custom Hooks
import { useBreakpoint } from 'hooks'

// Antd
import { Spin } from 'antd'

const BaseAssessmentStep = ({ steps, onChange, loading }: IBaseAssessmentStepProps) => {
  // Hook
  const { isMobile } = useBreakpoint()

  /**
   * @description Render Steps Image
   *
   * @param {object} step
   * @param {number} index
   *
   * @return {any} any
   */
  const _renderStepsImage = useCallback(
    (step: IAssessmentDetailStep, index: number) => {
      const isFirst: boolean = index === 0
      const isMiddle: boolean = index > 0 && index < steps.length - 1
      const isEnd: boolean = index === steps.length - 1

      // Check for mobile
      if (isMobile) {
        if (step.isActive) return StepActiveMiddle
        else return StepMiddle
      } else {
        // For first step
        if (isFirst) {
          if (step.isActive) return StepFirstActive
          else return StepFirst
        }
        // For last step
        else if (isEnd) {
          if (step.isActive) return StepEndActive
          else return StepEnd
        }
        // For middle step
        else if (isMiddle) {
          if (step.isActive) return StepActiveMiddle
          else return StepMiddle
        } else {
          return StepMiddle
        }
      }
    },
    [steps, isMobile],
  )

  return (
    <div className="w-full">
      <Spin spinning={loading || false}>
        <div className={`grid grid-cols-1 lg:grid-cols-${steps.length}`}>
          {steps.map((step, index) => (
            <div
              className={`${styles.wrapper} mb-4 lg:mb-0`}
              key={step.name}
              onClick={() => (!step.isUnlocked ? undefined : onChange && onChange(step.name!))}
              style={{
                cursor: !step.isUnlocked ? 'no-drop' : 'pointer',
              }}
            >
              <div
                className={`${styles.label} ${
                  step.isActive ? styles.active : !step.isUnlocked && !step.isActive ? 'text-grey' : ''
                }`}
              >
                <p>{step.name === 'Preparation' ? 'Pra-Assessment' : step.name}</p>
              </div>
              <img src={_renderStepsImage(step, index)} alt={'Step'} />
            </div>
          ))}
        </div>
      </Spin>
    </div>
  )
}

export { BaseAssessmentStep }
